import { css } from "@compiled/react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { Team24AdBanner } from "../../../../../patterns/team-24-ad-banner";

import { team24AdBannerConfluencei18n } from "./team-24-ad-banner.confluence.messages";

export interface Gradient {
    firstColor: string;
    secondColor: string;
}

export type Team24AdBannerConfluenceProps = {
    readonly gradient: Gradient;
};

export const Team24AdBannerConfluence = ({
    gradient
}: Team24AdBannerConfluenceProps) => {
    const bannerContainerStyles = css({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: `linear-gradient( to top, ${gradient.firstColor} 50%, ${gradient.secondColor} 50%)`
    });

    const { createAnalyticsEvent } = useAnalyticsEvents();
    return (
        <div css={bannerContainerStyles}>
            <Team24AdBanner
                team24LogoAlt={team24AdBannerConfluencei18n.team24LogoAlt}
                team24LogoDesktopUrl={
                    "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-ad-banner-confluence-logo-desktop.webp-1192641009.webp"
                }
                adCopyTitle={team24AdBannerConfluencei18n.adCopyTitle}
                adCopyParagraph={team24AdBannerConfluencei18n.adCopyParagraph}
                callToActionUrl={
                    "https://events.atlassian.com/team?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=confluence_lifted_bar&utm_medium=web"
                }
                callToActionText={team24AdBannerConfluencei18n.callToActionText}
                callToActionIconLabel={
                    team24AdBannerConfluencei18n.callToActionIconLabel
                }
                onClickFunc={() => {
                    createAnalyticsEvent({
                        eventType: "ui",
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "wacTeam24AdBanner",
                        source: "/software/confluence",
                        attributes: {
                            atlasId: "ATLAS-58452"
                        }
                    }).fire();
                }}
            />
        </div>
    );
};
